import { useRef, useEffect } from 'react';

export default function useOutsideClick(onOutsideClick, condition) {
  const elementRef = useRef(null);

  const handleClick = e => {
    if (elementRef.current !== null && !elementRef.current.contains(e.target)) {
      Promise.resolve(onOutsideClick(e)).then(() => {
        document.removeEventListener('click', onOutsideClick);
      });
    }
  };

  const onEscPress = e => {
    if (e.key === 'Escape') {
      Promise.resolve(onOutsideClick(e)).then(() => {
        document.removeEventListener('keydown', onOutsideClick);
      });
    }
  };

  useEffect(() => {
    if (condition) {
      document.addEventListener('click', handleClick, { passive: true });
      document.addEventListener('keydown', onEscPress, { passive: true });
    }
  }, [condition]);

  return elementRef;
}
